import { useQuery } from "@tanstack/react-query";
import { orgBillingApi, type OrgQuota } from "@/api/org-billing-api";
import { useActiveOrg } from "@/hooks/use-active-org";

export function useOrgQuota() {
  const { orgId } = useActiveOrg();

  const { data: quota, isLoading, error } = useQuery<OrgQuota>({
    queryKey: ["orgQuota", orgId],
    queryFn: () => orgBillingApi.getQuota(orgId!),
    enabled: !!orgId,
    staleTime: 5 * 60 * 1000,
    // 403s (stale activeWorkspace pointing at an org the user isn't in) should
    // surface immediately instead of spending four retries getting the same no.
    retry: false,
  });

  return { quota, isLoading, error, orgId };
}
